import script from "./memberDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./memberDetail.vue?vue&type=script&setup=true&lang=js"

import "./memberDetail.vue?vue&type=style&index=0&id=489e0d42&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489e0d42"]])

export default __exports__